module.exports = __webpack_public_path__ + "img/bottom-divider.fb7c06c3.png";